<template>
    <div>
        <UtilsContent @close-action="closeReading">
            <template v-slot:header>
                <div class="d-flex flex-column justify-center align-start">
                    <div class="d-flex flex-row justify-start align-center mx-3 mb-4">
                        <img :src="musicImg" class="img-index mr-2" alt="" />
                        <span class="text-h5 ma-0 text--primary">
                            {{ $t('bookReading.storyletter') }}
                        </span>
                    </div>
                    <div class="d-flex flex-row justify-start align-center mx-3 mb-4">
                        <span class="text-body-2 ma-0 text--primary text-left">
                            {{ $t('bookReading.readaloud_msg_1') }}
                        </span>
                    </div>
                    <v-snackbar v-model="snackbar" :timeout="timeout" color="error" top>
                        <p class="font-size-16 font-weigth-regular mb-0">
                            {{ $t('bookReading.not_storyteller_data_found') }}
                        </p>
                        <template v-slot:action="{ attrs }">
                            <v-btn icon v-bind="attrs" @click="snackbar = false">
                                <v-icon class="white--text">mdi-close</v-icon>
                            </v-btn>
                        </template>
                    </v-snackbar>
                </div>
            </template>
            <template v-slot:content>
                <div class="d-flex flex-column mx-3">
                    <v-row justify="start" align="start">
                        <v-col cols="12" class="d-flex flex-column justify-start align-start">
                            <span class="text--primary font-size-14">
                                {{ $t('bookReading.choose_voice') }}
                            </span>
                            <v-btn-toggle
                                color="primary"
                                v-model="currentVoice"
                                rounded
                                class="w-100 mt-3 primary--border"
                            >
                                <v-btn
                                    :value="voice"
                                    v-for="(voice, index) of voices"
                                    :key="index"
                                    class="d-flex justify-center w-50 align-center font-weight-bold font-size-14"
                                    :disabled="activeNarration"
                                >
                                    <span>{{ voice }}</span>
                                </v-btn>
                            </v-btn-toggle>
                        </v-col>
                        <v-col cols="12" class="d-flex flex-column justify-start align-start">
                            <ReadAloudPreview :current-voice="currentVoice" />
                        </v-col>
                        <v-col cols="12" class="d-flex flex-column justify-start align-start">
                            <VoiceVolumeSelector>
                                <v-slider
                                    min="0"
                                    max="100"
                                    color="primary"
                                    height="15"
                                    hide-details
                                    v-model="volume"
                                />
                            </VoiceVolumeSelector>
                        </v-col>
                    </v-row>
                </div>
            </template>
            <template v-slot:actions>
                <v-row justify="center" align="center">
                    <v-btn
                        data-cy="readALoud-activate-button"
                        color="secondary"
                        rounded
                        class="mt-4 mx-3 w-90 py-5 white--text"
                        @click="readCurrentText"
                        :loading="loading"
                    >
                        {{
                            !isNarratorActive ? $t('bookReading.activate') : $t('bookReading.desactivate')
                        }}
                        {{ $t('bookReading.reading_aloud') }}
                    </v-btn>
                </v-row>
            </template>
        </UtilsContent>
    </div>
</template>
<script>
/* eslint-disable global-require */
/* eslint-disable no-undef */

import UtilsContent from '@/components/core/utils/UtilsContent.vue'
import ReadAloudPreview from '@/components/core/utils/ReadAloudPreview.vue'
import VoiceVolumeSelector from '@/components/core/utils/VoiceVolumeSelector.vue'
import Markjs from '../../../mixins/Markjs'

export default {
    name: "ReadAloud",
    components: {
        UtilsContent,
        ReadAloudPreview,
        VoiceVolumeSelector,
    },
    data: () => ({
        musicImg: require('@/assets/img/icons/reading/icon-readaloud-2.svg'),
        volume: 25,
        snackbar: false,
        timeout: 3000,
    }),
    mixins: [Markjs]
}
</script>
